import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getFareData,
  getSelectedFareShelfRatings,
  useFlightCard as useCoreFlightCard,
} from "@b2bportal/core-flights";
import { getCheapestFilteredFare } from "@b2bportal/core-utilities";
import { trackEvent } from "@hopper-b2b/api";
import { SELECTED_FLIGHT, VIEWED_SLICE } from "@hopper-b2b/types";
import { getSelectedSliceProperties } from "@hsbc/utilities";
import { usePriceDisplay } from "@tenant/ui";

export const useFlightCard = (params) => {
  const {
    flight: { fares },
  } = params;

  const fareData = useSelector((state) => getFareData(state, fares));
  const fareShelfFilter = useSelector(getSelectedFareShelfRatings);

  const cheapestFiltedFare = getCheapestFilteredFare(fareData, fareShelfFilter);

  const { context, handlers } = useCoreFlightCard(params);
  const { priceText: currentPriceText, rewardsText: currentPointsText } =
    usePriceDisplay({
      prices: cheapestFiltedFare.price,
      formatOptions: {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      },
    });

  const viewedSliceProperties = useSelector(getSelectedSliceProperties);
  useEffect(() => {
    if (context.open && !context.isFlightDetailsLoading) {
      trackEvent({
        eventName: VIEWED_SLICE,
        properties: {
          ...viewedSliceProperties,
          total_stops:
            context.flightDetails?.slices?.reduce(
              (acc, slice) => acc + slice?.stops,
              0
            ) || 0,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.open, context.isFlightDetailsLoading]);

  useEffect(() => {
    if (context.openFlightDetailsDialog) {
      trackEvent({
        eventName: SELECTED_FLIGHT,
        properties: { ...viewedSliceProperties },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.openFlightDetailsDialog]);

  return {
    context: {
      ...context,
      flightCardSummary: {
        ...context.flightCardSummary,
        currentPriceText,
        currentPointsText,
      },
    },
    handlers,
  };
};
